// extracted by mini-css-extract-plugin
module.exports = {"prompt":"style_prompt__h8F6T","radios":"style_radios__QvSBC"};